import { TOptions, t as t18 } from "i18next";

export const namespaces = [
  'portal-lib'
]
  ;
export const AvailableLocales = ['sv-SE', 'nl-NL', 'fr-FR', 'en-US', 'en-GB'] as const;

export type AvailableLocaleType = (typeof AvailableLocales)[number];

export const tPortalLib = {
  accountCard: {
    balance(options: TOptions = {}) {
      return t18('portal-lib:accountCard.balance', options);
    },
    balanceHiddenText(options: TOptions = {}) {
      return t18('portal-lib:accountCard.balanceHiddenText', options);
    },
    credit(options: TOptions = {}) {
      return t18('portal-lib:accountCard.credit', options);
    },
    direct(options: TOptions = {}) {
      return t18('portal-lib:accountCard.direct', options);
    },
    showQrCode(options: TOptions = {}) {
      return t18('portal-lib:accountCard.showQrCode', options);
    },
    spentCreditOf(options: TOptions<{ creditLimit: string; } & Record<string, any>>) {
      return t18('portal-lib:accountCard.spentCreditOf', options);
    },
    toggleBalance(options: TOptions = {}) {
      return t18('portal-lib:accountCard.toggleBalance', options);
    },
  },
  general: {
    and(options: TOptions = {}) {
      return t18('portal-lib:general.and', options);
    },
    kcal(options: TOptions<{ kcal: string; } & Record<string, any>>) {
      return t18('portal-lib:general.kcal', options);
    },
    new(options: TOptions = {}) {
      return t18('portal-lib:general.new', options);
    },
    success(options: TOptions = {}) {
      return t18('portal-lib:general.success', options);
    },
  },
  login: {
    doNotHaveAccount(options: TOptions = {}) {
      return t18('portal-lib:login.doNotHaveAccount', options);
    },
    logIn(options: TOptions = {}) {
      return t18('portal-lib:login.logIn', options);
    },
    signUp(options: TOptions = {}) {
      return t18('portal-lib:login.signUp', options);
    },
  },
  news: {
    a11y: {
      readArticle(options: TOptions<{ title: string; } & Record<string, any>>) {
        return t18('portal-lib:news.a11y.readArticle', options);
      },
    },
    newsRelatedTo(options: TOptions<{ name: string; } & Record<string, any>>) {
      return t18('portal-lib:news.newsRelatedTo', options);
    },
    newsRelatedToGlobal(options: TOptions<{ name: string; } & Record<string, any>>) {
      return t18('portal-lib:news.newsRelatedToGlobal', options);
    },
  },
  siteUnits: {
    addFavourite(options: TOptions = {}) {
      return t18('portal-lib:siteUnits.addFavourite', options);
    },
    orderNow(options: TOptions = {}) {
      return t18('portal-lib:siteUnits.orderNow', options);
    },
    removeFavourite(options: TOptions = {}) {
      return t18('portal-lib:siteUnits.removeFavourite', options);
    },
  },
  vouchers: {
    allSites(options: TOptions = {}) {
      return t18('portal-lib:vouchers.allSites', options);
    },
    automaticVoucher(options: TOptions = {}) {
      return t18('portal-lib:vouchers.automaticVoucher', options);
    },
    claimed(options: TOptions<{ claimDate: string; } & Record<string, any>>) {
      return t18('portal-lib:vouchers.claimed', options);
    },
    expired(options: TOptions<{ expirationDate: string; } & Record<string, any>>) {
      return t18('portal-lib:vouchers.expired', options);
    },
    manualVoucher(options: TOptions = {}) {
      return t18('portal-lib:vouchers.manualVoucher', options);
    },
    oneTimeUsage(options: TOptions = {}) {
      return t18('portal-lib:vouchers.oneTimeUsage', options);
    },
    openToUse(options: TOptions = {}) {
      return t18('portal-lib:vouchers.openToUse', options);
    },
    uses(options: TOptions<{ claims: string; maxClaims: string; } & Record<string, any>>) {
      return t18('portal-lib:vouchers.uses', options);
    },
    validAt(options: TOptions<{ validAt: string; } & Record<string, any>>) {
      return t18('portal-lib:vouchers.validAt', options);
    },
    validUntil(options: TOptions<{ validUntil: string; } & Record<string, any>>) {
      return t18('portal-lib:vouchers.validUntil', options);
    },
  },
};
